import { Storyblok } from '#library/storyblok.svelte.ts'
import type { Layout } from '#library/components.schema.build.ts'
import { error } from '@sveltejs/kit'

export async function load({ data: { production, version, prospectus } }) {
	await Storyblok.init()

	const api = Storyblok.api()

	try {
		const layout = await api.getStory('layout', { version, resolve_links: 'url' })

		return {
			version,
			api,
			layout: layout.data.story.content as Layout,
			// deliberately not awaited — menu.svelte renders this behind {#await}
			news: api.get('cdn/stories', {
				version,
				content_type: 'news',
				starts_with: 'journal/',
				per_page: 2,
				is_startpage: false,
				sort_by: 'first_published_at:desc',
				resolve_links: 'url'
			}),
			production,
			prospectus
		}
	} catch (_error) {
		error(500, 'Failed to fetch layout')
	}
}
